import classNames from 'classnames';
import { IS_SERVER } from 'src/utils/checkRenderEnv';
import { KeyboardArrowRight } from '@mui/icons-material';
import { getRoute, PATH } from 'src/utils/routes';
import { useSSRSelector } from 'src/redux/ssrStore';
import { validateLink } from 'src/utils/validateLink';
import { isPLPRequiredSystem } from 'src/utils/isPLPRequiredSystem';
import { getRedirectLinkForSlug } from '../../Widgets2.0/Header/utils';
import { smartWordBreakStyle } from 'src/utils/smartWordBreakStyle';
import CommonLinkWrapper from '../../Widgets2.0/CommonLinkWrapper';

export const Option = ({
  option,
  idx,
  renderArray,
  isShopComponent,
  customItemConfigs,
  onNavItemClick,
  fromMobileMenuDrawer,
  handleMouseAction,
  isSubNavListActive,
  categories,
}) => {
  const { store, navigationList } = useSSRSelector((state) => ({
    store: state.storeReducer.store,
    navigationList: state.additionalPagesReducer.navigationList,
  }));

  const isNavLinkActive =
    !IS_SERVER && !!option.redirectionLink
      ? window.location.pathname.includes(
          option.redirectionLink?.startsWith('/')
            ? option.redirectionLink
            : `/${option.redirectionLink}`
        )
      : false;

  const { onLinkHoverEnter, onLinkHoverLeave, getNavElementStyle } =
    customItemConfigs || {};
  const isLastOption = idx === renderArray.length - 1;
  const hasSubNavList = option?.type === 'dropdown';

  function getShopCategoryLink() {
    const currentCategory = categories?.find((val) => val?.name === option?.name);
    return getRoute(
      `${
        isPLPRequiredSystem(store?.theme?.theme_class) ? PATH.SHOP : PATH.PRODUCT
      }?cid=${currentCategory?.id || option?.id}`,
      store?.store_info?.domain
    );
  }

  const redirectionLink = isShopComponent
    ? getShopCategoryLink()
    : getRoute(
        getRedirectLinkForSlug(
          navigationList,
          validateLink(option.redirectionLink),
          option.id
        ),
        store?.store_info?.domain
      );

  const OptionName = (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
      {option.name}
      {hasSubNavList && <KeyboardArrowRight fontSize="small" />}
    </div>
  );

  return (
    <CommonLinkWrapper
      key={option.name}
      className={classNames(
        'tw-relative tw-px-[20px] [&>.underline-comp]:hover:tw-block',
        ((!option?.redirectionLink || isNavLinkActive) &&
          !isShopComponent &&
          !Object.hasOwn(option, 'id')) ||
          hasSubNavList
          ? 'tw-pointer-events-none'
          : ' '
      )}
      onMouseOver={(e) => handleMouseAction?.(e.target)}
      link={redirectionLink}
      disableLink={option.redirectNewPage}
      handleCustomClick={() => {
        if (option.redirectNewPage && !hasSubNavList) onNavItemClick(option);
      }}
    >
      <p
        onMouseEnter={() => onLinkHoverEnter(idx)}
        onMouseLeave={onLinkHoverLeave}
        style={{
          ...(getNavElementStyle ? getNavElementStyle(idx) : {}),
          ...smartWordBreakStyle,
        }}
        className={
          'tw-relative tw-w-fit tw-max-w-[150px] tw-select-none tw-whitespace-normal tw-leading-normal hover:!tw-font-semibold [&_.underline-comp]:hover:tw-block ' +
          (!fromMobileMenuDrawer
            ? 'tw-m-0 tw-text-[12px] tw-tracking-[0.95px] ' +
              (!isLastOption ? 'tw-pb-[16px]' : '')
            : 'tw-m-0  ' + (!isLastOption ? 'tw-pb-[17.5px]' : '')) +
          (isSubNavListActive ? ' !tw-font-semibold' : '') +
          (hasSubNavList ? ' !tw-w-full' : '')
        }
        key={idx.id}
      >
        {OptionName}
      </p>
    </CommonLinkWrapper>
  );
};
